// removed by extract-text-webpack-plugin
module.exports = {"BackButton":"BackButton__BackButton___10qIr","BackButtonSmall":"BackButton__BackButtonSmall___2BM8S"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/BackButton/BackButton.less
// module id = 1111
// module chunks = 0 1